import { isPlatformBrowser } from '@angular/common';
import {
  Directive,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  inject
} from '@angular/core';
import { Menu } from 'primeng/menu';
import { Popover } from 'primeng/popover';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'p-popover[mHideOnWindowScroll], p-menu[mHideOnWindowScroll]',
  standalone: true
})
export class HideOnWindowScrollDirective implements OnInit, OnDestroy {
  private readonly renderer = inject(Renderer2);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly popover = inject(Popover, { self: true, optional: true });
  private readonly menu = inject(Menu, { self: true, optional: true });

  private unlisten?: () => void;
  private readonly subs = new Subscription();

  ngOnInit(): void {
    const overlay = this.popover ?? this.menu;
    if (!overlay) {
      return;
    }
    this.subs.add(overlay.onShow.subscribe(() => this.bind()));
    this.subs.add(overlay.onHide.subscribe(() => this.unbind()));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.unbind();
  }

  private bind(): void {
    if (!isPlatformBrowser(this.platformId) || this.unlisten) {
      return;
    }
    this.unlisten = this.renderer.listen('window', 'scroll', () => {
      this.popover?.hide();
      this.menu?.hide();
    });
  }

  private unbind(): void {
    this.unlisten?.();
    this.unlisten = undefined;
  }
}
